import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchLogin, fetchVerifyOTP } from "./loginAPI";

import {
  LoginState,
  LoginValues,
} from "../../../features/view/public/loginPage/loginTypes";

const initialState: LoginState = {
  verify: { token: "", loader: false },
  login: { otp: null, loader: false },
};

export const loginAsync = createAsyncThunk(
  "login/user",
  async (payload: LoginValues) => {
    const response = await fetchLogin(payload);
    return response;
  }
);
export const loginVerifyOTPAsync = createAsyncThunk(
  "login/user/verify/otp",
  async (payload: LoginValues) => {
    const response = await fetchVerifyOTP(payload);
    return response;
  }
);
export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setToken: (state, action) => {
      state.verify.token = action.payload;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => {
        state.login.loader = true;
      })
      .addCase(loginAsync.fulfilled, (state, action: any) => {
        state.login.loader = false;
        state.login.otp = action.payload.data.otp;
      })
      .addCase(loginAsync.rejected, (state) => {
        state.login.loader = false;
      })
      .addCase(loginVerifyOTPAsync.pending, (state) => {
        state.verify.loader = true;
      })
      .addCase(loginVerifyOTPAsync.fulfilled, (state, action: any) => {
        state.verify.loader = false;
        state.verify.token = action.payload.data.jwt_token;
      })
      .addCase(loginVerifyOTPAsync.rejected, (state) => {
        state.verify.loader = false;
      });
  },
});
export const {
  // setUserDetails,
  setToken,
} = loginSlice.actions;

export default loginSlice.reducer;
